module.exports = __webpack_public_path__ + "static/media/event-services-img39.4b20a36c.jpg";